import {BrowserRouter, Outlet, Route, Routes} from 'react-router-dom';
import './App.css';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import Group from './pages/Group';
import Dashboard from './pages/Dashboard';
import Category from './pages/Category';
import NotFound from './pages/NotFound';
import Table from './pages/Table';
import Metadata from './pages/Metadata';
import {TableContent} from './pages/TableContent';
import UserManagement from './pages/UserManagement';
import Landing from './pages/Landing';
import TableAPIInterface from './pages/TableAPIInterface';
import DatasetList from './pages/DatasetList';
import DatasetDetail from './pages/DatasetDetail';
import GlobalNavbar from './components/GlobalNavbar';
import Search from './pages/Search';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Landing />} />
        <Route path='/login' element={<Login />} />
        <Route path='/dataset' element={<DatasetList />} />
        <Route path='/dataset/:id' element={<DatasetDetail />} />

        <Route element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route path="/dashboard" element={
            <ProtectedRoute allowedRoles={['super_admin', 'admin', 'operator', 'consumer']}>
              <Dashboard />
            </ProtectedRoute>
          } />
        
          <Route path='/users' element={
            <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
              <UserManagement />
            </ProtectedRoute>
          } />       

          <Route element={
            <ProtectedRoute allowedRoles={['consumer']}>
              <Outlet />
            </ProtectedRoute>
          }>
            <Route path="/data/:tableId" element={<TableAPIInterface />} />
          </Route>

          <Route element={
            <ProtectedRoute allowedRoles={['super_admin', 'admin', 'operator', 'consumer']}>
              <Outlet />
            </ProtectedRoute>
          }>
            <Route path="/search" element={<Search />} />
            <Route path="/data/group" element={<Group />} />
            <Route path="/data/:groupId/category" element={<Category />} />
            <Route path="/data/:groupId/:categoryId/table" element={<Table />} />
            <Route path="/data/:tableId/metadata" element={<Metadata />} />
            <Route path="/data/:groupId/:categoryId/:tableId" element={<TableContent />} />
          </Route>

          <Route path='*' element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function Layout() {
  return (
    <div className="flex h-screen bg-neutral-50 overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <GlobalNavbar />
        <main className="flex-1 overflow-auto p-6 custom-scrollbar">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
